<p-sidebar
  [visible]="sidebarVisible"
  (visibleChange)="onSidebarVisibleChange($event)"
  styleClass="notification-sidebar"
  [position]="position"
  [transitionOptions]="sidebarTransitionOptions"
  appendTo="body"
  [blockScroll]="true"
  [dismissible]="true"
  [showCloseIcon]="true"
  [modal]="true"
  [autoZIndex]="true"
  [baseZIndex]="1100">
  <ng-template pTemplate="content">
    <div class="lk-eu-informer">
      <header class="lk-eu-informer__header">
        <div class="lk-eu-informer__header-row">
          <h2 class="lk-eu-informer__title">Уведомления</h2>
          <crm-button
            type="button"
            icon="pi pi-refresh"
            pTooltip="Обновить"
            tooltipPosition="left"
            styleClass="lk-eu-informer-refresh p-button-rounded p-button-text"
            (onClick)="refreshActiveList()"></crm-button>
        </div>

        <nav
          class="lk-eu-informer-tabs"
          role="tablist"
          aria-label="Разделы уведомлений">
          @for (item of informerTypeOptions; track item.value) {
            @if (item.visible) {
              <button
                type="button"
                role="tab"
                class="lk-eu-informer-tab"
                [class.lk-eu-informer-tab--active]="selectedInformerType === item.value"
                [attr.aria-selected]="selectedInformerType === item.value"
                (click)="selectInformerType(item.value)">
                <i
                  [ngClass]="['lk-eu-informer-tab__icon', item.icon]"
                  aria-hidden="true"></i>
                <span class="lk-eu-informer-tab__label">{{ item.label }}</span>
                @if (getUnreadCount(item.value); as unreadCount) {
                  @if (unreadCount > 0) {
                    <span class="lk-eu-informer-tab__badge">
                      {{ unreadCount > 99 ? '99+' : unreadCount }}
                    </span>
                  }
                }
              </button>
            }
          }
        </nav>
      </header>

      <div class="lk-eu-informer__body">
        <div
          *ngIf="selectedInformerType !== 'FAVORITE'"
          class="lk-eu-informer__pane"
          role="tabpanel">
          <crm-lk-eu-notification-list
            [informerType]="$any(selectedInformerType)"
            (closeSidebar)="closeSidebar()"></crm-lk-eu-notification-list>
        </div>

        <div
          *ngIf="selectedInformerType === 'FAVORITE'"
          class="lk-eu-informer__pane"
          role="tabpanel">
          <crm-lk-eu-notification-favorite-list (closeSidebar)="closeSidebar()"></crm-lk-eu-notification-favorite-list>
        </div>
      </div>
    </div>
  </ng-template>
</p-sidebar>
